import { styled } from "styled-components";
import { Modal, Tooltip } from "antd";
import {
  DataSourceStatus,
  DatabaseType,
  FileType,
  IDataSource,
  IPageableResponse,
  Loading,
  scrollBarStyles,
} from "@dataone/lib";
import { Row, Col } from "antd";
import DatabaseListHead from "../database/database-list-head/DatabaseListHead";
import {
  CsvIcon,
  ExcelIcon,
  MongodbIcon,
  MysqlIcon,
  OracleIcon,
  PostgresqlIcon,
  SqlServerIcon,
} from "@dataone/icons";

interface DataSourcesModalProps {
  children?: React.ReactNode;
  isModalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  datasources: IPageableResponse<Required<IDataSource>> | undefined;
  isLoading: boolean;
  selectedDB: IDataSource | null;
  handleDBClick: (database: IDataSource) => void;
  dataSourceLoading: boolean;
  clickedDatabaseId: string;
}

const DataSourcesModal = ({
  isModalOpen,
  setModalOpen,
  datasources,
  isLoading,
  selectedDB,
  handleDBClick,
  dataSourceLoading,
  clickedDatabaseId,
}: DataSourcesModalProps) => {
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  return (
    <StyledDataSourcesModal
      getContainer="#smartsearch-modal"
      wrapClassName="absolute-modal-wrap"
      styles={{
        mask: { position: "absolute", borderRadius: "20px 40px 40px 40px" },
      }}
      open={isModalOpen}
      onCancel={handleCloseModal}
    >
      <div>
        <DatabaseListHead
          selectedDB={selectedDB}
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          datasources={datasources}
        />
      </div>
      <div>
        {/* <Row gutter={[16, 16]}> */}
        <Row>
          {isLoading ? (
            <Loading />
          ) : (
            datasources?.content?.map((database) => (
              // <Col key={database.id} span={6}>
              <Col key={database.id}>
                <StyledDataBase dataSourceloading={dataSourceLoading}>
                  <div
                    className={`database ${
                      selectedDB?.id === database.id && "selected"
                    } ${
                      database.status === DataSourceStatus.DEACTIVATE &&
                      "disabled-database"
                    }`}
                    onClick={() => {
                      handleCloseModal();
                      handleDBClick(database);
                    }}
                  >
                    <div>
                      {dataSourceLoading &&
                      clickedDatabaseId === database.id ? (
                        <img
                          height={30}
                          alt="dataset"
                          src="images/smart-search/ds-loading.gif"
                        />
                      ) : (
                        <img
                          height={30}
                          alt="dataset"
                          src={`images/data-management/datasources_icons/icon-${
                            database.internalType === DatabaseType.MYSQL
                              ? "mysql"
                              : database.internalType === DatabaseType.SQLSERVER
                              ? "sql-server"
                              : database.internalType === DatabaseType.SAP
                              ? "sap"
                              : database.internalType ===
                                DatabaseType.POSTGRESQL
                              ? "postgresql"
                              : database.internalType === DatabaseType.SAGE
                              ? "sage"
                              : database.internalType === FileType.EXCEL
                              ? "sheets"
                              : "csv"
                          }.svg`}
                        />
                        // <StyledIcon>
                        //   {database.internalType === DatabaseType.MYSQL ? (
                        //     <MysqlIcon />
                        //   ) : database.internalType ===
                        //     DatabaseType.SQLSERVER ? (
                        //     <SqlServerIcon />
                        //   ) : database.internalType === DatabaseType.MONGODB ? (
                        //     <MongodbIcon />
                        //   ) : database.internalType ===
                        //     DatabaseType.POSTGRESQL ? (
                        //     <PostgresqlIcon />
                        //   ) : database.internalType === DatabaseType.ORACLE ? (
                        //     <OracleIcon />
                        //   ) : database.internalType === FileType.EXCEL ? (
                        //     <ExcelIcon />
                        //   ) : (
                        //     <CsvIcon />
                        //   )}
                        // </StyledIcon>
                      )}
                    </div>
                    <StyledDetails>
                      <div
                        className={`name ${
                          database.status === DataSourceStatus.DEACTIVATE &&
                          "disabled-database"
                        }`}
                      >
                        <Tooltip
                          placement="topLeft"
                          title={
                            <span style={{ fontSize: "12px" }}>
                              {database.displayName}
                            </span>
                          }
                        >
                          {database.displayName}
                        </Tooltip>
                      </div>
                      <div>{database.internalType}</div>
                    </StyledDetails>
                  </div>
                </StyledDataBase>
              </Col>
            ))
          )}
        </Row>
      </div>
    </StyledDataSourcesModal>
  );
};

export default DataSourcesModal;

const StyledDataSourcesModal = styled(Modal)`
  .ant-col {
    // width: 180px;
    width: 168px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-row {
    margin-top: 15px;
    // justify-content: space-between;
    max-height: 400px;
    height: 400px;
    overflow: auto;
    ${scrollBarStyles}
  }
  .ant-modal-content {
    border-radius: 20px;
  }
`;

const StyledDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
`;
const StyledDataBase = styled.div<{ dataSourceloading: boolean }>`
  margin: 10px;
  cursor: ${(props) => (props.dataSourceloading ? "not-allowed" : "pointer")};
  &:hover {
    background: #eff1fd;
    border-radius: 10px;
    color: #4974f6;
  }
  .database {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px;
    &.disabled-database {
      opacity: 0.6;
      cursor: not-allowed;
    }
    &.selected {
      background: #eff1fd;
      border-radius: 10px;
      color: #4974f6;
    }
    img {
      width: 20px;
      height: 28px;
      // margin-top: 6px;
      display: flex;
    }
  }
  .name {
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    font-weight: 700;
    &.disabled-database {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  img {
    min-width: 50px;
    padding-right: 10px;
  }
`;

const StyledIcon = styled.div`
  font-size: 18px;
`;
